import React from 'react';
import styled from 'styled-components';

import { getDefaultErrorColor, getDefaultTextColor } from '../../lib/colorPicker';
import Warning from '../icons/Warning';

const EditableColorBox = ({ id, color, title, showWarning = false, onChange }: {
  id: string,
  color: string,
  title: string,
  showWarning?: boolean,
  onChange: (color: string) => void
}) => {
  return <Box>
    <InvisibleInput id={id} type="color" value={color} onChange={(e) => onChange(e.currentTarget.value)}/>
    <ColorBox $color={color} $borderColor={getDefaultTextColor(color)} htmlFor={id} title={title}>
      {/*{ showWarning ? <WarningContainer><Warning color={getDefaultErrorColor(color)} size={15}/></WarningContainer> : null }*/}
    </ColorBox>
    <Label>{title}</Label>
  </Box>;
};

const Box = styled.div`
  text-align: center;
`;

const InvisibleInput = styled.input`
  height: 0;
  width: 0;
  border: 0;
  opacity: 0;
  padding: 0;
`;

const ColorBox = styled.label<{ $color: string, $borderColor: string }>`
  display: inline-block;
  margin: 5px;
  width: 40px;
  height: 40px;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  border-radius: 3px;
  background-color: ${({ $color }) => $color};
  cursor: pointer;
  position: relative;
`;

const WarningContainer = styled.div`
  position: absolute;
  top: 1px;
  left: 1px;
`;

const Label = styled.div`
  font-family: Poppins, sans-serif;
  font-size: 12px;
  font-weight: 300;
  margin: 0 5px 10px;
  width: 60px;
  color: var(--shine-background-text-color);
`;

export default EditableColorBox;
